import { render } from "./Notication.vue?vue&type=template&id=b7a25386&scoped=true"
import script from "./Notication.vue?vue&type=script&lang=js"
export * from "./Notication.vue?vue&type=script&lang=js"

import "./Notication.vue?vue&type=style&index=0&id=b7a25386&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7a25386"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon,QDate,QTabPanels,QTabPanel});
